import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiButtonComponent } from '../ui-button/ui-button.component';
import { UiStateTone } from '../../types/ui-state-tone.type';

@Component({
  selector: 'ui-empty-state',
  imports: [UiButtonComponent],
  templateUrl: './ui-empty-state.component.html',
  styleUrl: './ui-empty-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiEmptyStateComponent {
  public readonly title: InputSignal<string> = input.required<string>();
  public readonly description: InputSignal<string | null> = input<string | null>(null);
  public readonly iconLabel: InputSignal<string> = input<string>('i');
  public readonly actionLabel: InputSignal<string | null> = input<string | null>(null);
  public readonly tone: InputSignal<UiStateTone> = input<UiStateTone>('neutral');
  public readonly actionSelected: OutputEmitterRef<void> = output<void>();

  protected readonly hasDescription: Signal<boolean> = computed((): boolean => !!this.description());
  protected readonly hasAction: Signal<boolean> = computed((): boolean => !!this.actionLabel());
  protected readonly isNeutral: Signal<boolean> = computed((): boolean => this.tone() === 'neutral');
  protected readonly isInfo: Signal<boolean> = computed((): boolean => this.tone() === 'info');
  protected readonly isSuccess: Signal<boolean> = computed((): boolean => this.tone() === 'success');
  protected readonly isWarning: Signal<boolean> = computed((): boolean => this.tone() === 'warning');
  protected readonly isDanger: Signal<boolean> = computed((): boolean => this.tone() === 'danger');

  protected handleActionSelected(): void {
    this.actionSelected.emit();
  }
}
